var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 800,
        width: 1600,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", { attrs: { height: "310", width: "1600", y: "479", x: "0" } }),
      _vm._v(" "),
      _c("rect", { attrs: { height: "180", width: "1600", y: "17", x: "0" } }),
      _vm._v(" "),
      _c("rect", { attrs: { height: "240", width: "1600", y: "216", x: "0" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }